import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 12H19", stroke: "#18191F", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinus;
